angular.module('shbdeployer.docker').controller('ConfigController', [
  '$scope',
  '$transition$',
  '$state',
  'ConfigService',
  'Notifications',
  function ($scope, $transition$, $state, ConfigService, Notifications) {
    $scope.removeConfig = function removeConfig(configId) {
      ConfigService.remove(configId)
        .then(function success() {
          Notifications.success('Конфигурация удалена');
          $state.go('docker.configs', {});
        })
        .catch(function error(err) {
          Notifications.error('Ошибка', err, 'Не удалось удалить конфигурацию');
        });
    };

    function initView() {
      ConfigService.config($transition$.params().id)
        .then(function success(data) {
          $scope.config = data;
        })
        .catch(function error(err) {
          Notifications.error('Ошибка', err, 'Не удалось получить сведения о конфигурации');
        });
    }

    initView();
  },
]);
